import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import resourceApi from 'src/api/resource'
import productApi from 'src/api/product'

export const fetchResourceGroups = createAsyncThunk(
  'resource/fetchResourceGroups',
  async (locationId) => {
    const response = await resourceApi.getResourceGroups(locationId)
    return response
  }
)

const initialState = {
  isModalOpen: false,
  modalViewName: null,
  modalViewParams: null,
  reload: false,

  // current location context
  selectedLocationId: null,

  // flat list: [{ id, name, showInCalendar, locationId, resources: [...] }]
  resourceGroups: [],
  loading: false,
  error: '',
}

const slice = createSlice({
  name: 'resource',
  initialState,
  reducers: {
    openModal(state) {
      state.isModalOpen = true
    },
    closeModal(state) {
      state.isModalOpen = false
      state.modalViewName = null
      state.modalViewParams = null
    },
    setModalViewName(state, action) {
      state.modalViewName = action.payload
    },
    setModalViewParams(state, action) {
      state.modalViewParams = action.payload
    },
    setSelectedLocationId(state, action) {
      state.selectedLocationId = action.payload
    },
    setReload(state, action) {
      state.reload = action.payload
    },
    addResourceGroup(state, action) {
      state.resourceGroups = [action.payload, ...state.resourceGroups]
    },
    updateResourceGroup(state, action) {
      const updated = action.payload
      state.resourceGroups = state.resourceGroups.map((g) =>
        g.id === updated.id ? { ...g, ...updated } : g
      )
    },
    removeResourceGroup(state, action) {
      state.resourceGroups = state.resourceGroups.filter(
        (g) => g.id !== action.payload
      )
    },
    addResource(state, action) {
      const { groupId, resource } = action.payload
      state.resourceGroups = state.resourceGroups.map((g) =>
        g.id === groupId
          ? { ...g, resources: [...(g.resources || []), resource] }
          : g
      )
    },
    removeResource(state, action) {
      const { groupId, resourceId } = action.payload
      state.resourceGroups = state.resourceGroups.map((g) =>
        g.id === groupId
          ? {
              ...g,
              resources: (g.resources || []).filter((r) => r.id !== resourceId),
            }
          : g
      )
    },
    updateResource(state, action) {
      const { groupId, resource } = action.payload
      state.resourceGroups = state.resourceGroups.map((g) =>
        g.id === groupId
          ? {
              ...g,
              resources: (g.resources || []).map((r) =>
                r.id === resource.id ? { ...r, ...resource } : r
              ),
            }
          : g
      )
    },
  },
  extraReducers: {
    [fetchResourceGroups.pending]: (state) => {
      state.loading = true
      state.error = ''
    },
    [fetchResourceGroups.fulfilled]: (state, action) => {
      state.loading = false
      state.resourceGroups = action.payload || []
    },
    [fetchResourceGroups.rejected]: (state, action) => {
      state.loading = false
      state.error = action.error.message
    },
  },
})

export const {
  openModal,
  closeModal,
  setModalViewName,
  setModalViewParams,
  setSelectedLocationId,
  setReload,
  addResourceGroup,
  updateResourceGroup,
  removeResourceGroup,
  addResource,
  removeResource,
  updateResource,
} = slice.actions

export const reducer = slice.reducer
